module.exports = __webpack_public_path__ + "static/media/employees.9be7a31b.svg";